import React, { useState, useEffect } from "react";
import { Outlet, NavLink, useNavigate, useLocation } from "react-router-dom";
import jwtDecode from "jwt-decode";
import "./admin.css";

const AdminLayout = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [adminName, setAdminName] = useState("Admin");

    useEffect(() => {
        const token = localStorage.getItem("user");
        if (token) {
            try {
                const decoded = jwtDecode(token);
                setAdminName(decoded.name || decoded.email || "Admin");
            } catch (e) {
                console.error(e);
            }
        }
    }, []);

    const handleLogout = () => {
        localStorage.removeItem("user");
        navigate("/login");
    };

    const navItems = [
        { path: "/admin", icon: "fa-tachometer", label: "Dashboard", exact: true },
        { path: "/admin/users", icon: "fa-users", label: "User Management" },
        { path: "/admin/ads", icon: "fa-bullhorn", label: "Ads & Listings" },
        { path: "/admin/subscriptions", icon: "fa-credit-card", label: "Subscriptions" },
        { path: "/admin/categories", icon: "fa-th-large", label: "Categories" },
        { path: "/admin/countries", icon: "fa-globe", label: "Manage Country" },
        { path: "/admin/support", icon: "fa-life-ring", label: "Support" },
        { path: "/admin/reports", icon: "fa-flag", label: "Reports" },
        { path: "/admin/activity-logs", icon: "fa-history", label: "Activity Logs" },
        { path: "/admin/settings", icon: "fa-cogs", label: "System Settings" },
        { path: "/admin/profile", icon: "fa-user-circle", label: "My Profile" },
    ];

    const getPageTitle = () => {
        const current = navItems.find((item) => {
            if (item.exact) return location.pathname === item.path;
            return location.pathname.startsWith(item.path);
        });
        return current ? current.label : "Admin Panel";
    };

    return (
        <div className="admin-wrapper">
            {/* Sidebar */}
            <aside className={`admin-sidebar ${sidebarOpen ? "open" : ""}`}>
                <div className="admin-sidebar-brand">
                    <img src="/img/logo.png" alt="Carib Bargains" />
                    <span>Admin Panel</span>
                </div>
                <ul className="admin-nav">
                    {navItems.map((item) => (
                        <li
                            key={item.path}
                            className={
                                item.exact
                                    ? location.pathname === item.path
                                        ? "active"
                                        : ""
                                    : location.pathname.startsWith(item.path) &&
                                        location.pathname !== "/admin"
                                        ? "active"
                                        : !item.exact && location.pathname === "/admin" && item.path === "/admin"
                                            ? "active"
                                            : ""
                            }
                        >
                            <NavLink
                                to={item.path}
                                end={item.exact}
                                onClick={() => setSidebarOpen(false)}
                            >
                                <i className={`fa ${item.icon}`}></i>
                                {item.label}
                            </NavLink>
                        </li>
                    ))}
                    <div className="admin-nav-divider"></div>
                    <li>
                        <a
                            href="#logout"
                            onClick={(e) => {
                                e.preventDefault();
                                handleLogout();
                            }}
                        >
                            <i className="fa fa-sign-out"></i>
                            Logout
                        </a>
                    </li>
                </ul>
            </aside>

            {/* Main content */}
            <div className="admin-main">
                <div className="admin-topbar">
                    <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
                        <button
                            className="admin-hamburger"
                            onClick={() => setSidebarOpen(!sidebarOpen)}
                            style={{ color: "#fff" }}
                        >
                            <i className="fa fa-bars"></i>
                        </button>
                        <h1 className="admin-topbar-title">{getPageTitle()}</h1>
                    </div>
                    <div className="admin-topbar-right">
                        <div className="admin-topbar-user">
                            <i className="fa fa-user-circle" style={{ fontSize: "20px", color: "#fff" }}></i>
                            <span>{adminName}</span>
                        </div>
                        <button className="admin-topbar-logout" onClick={handleLogout}>
                            <i className="fa fa-power-off"></i> Logout
                        </button>
                    </div>
                </div>
                <div className="admin-content">
                    <Outlet />
                </div>
            </div>

            {/* Sidebar overlay for mobile */}
            {sidebarOpen && (
                <div
                    style={{
                        position: "fixed",
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        background: "rgba(0,0,0,0.4)",
                        zIndex: 999,
                    }}
                    onClick={() => setSidebarOpen(false)}
                ></div>
            )}
        </div>
    );
};

export default AdminLayout;
